<template>
    <div>
        <!-- selected filters label & clear all button -->
        <div class="mt-1 mb-2 hidden md:flex justify-between border-b-1">

            <span class="text-sm font-semibold">
                {{ filterLabelText.toUpperCase() }}
            </span>

            <button class="text-sm font-semibold text-gdc-red-600 hover:text-gdc-gray-600"
                    @click="clearFilters()"
                    v-if="this.activeFilters.length > 0">
                <span>{{ clearLabelText }}</span>
            </button>

        </div>
        <div class="w-full hidden sm:flex">
            <ul :class="['!list-none !m-0 !p-0 !ps-0 w-full', { 'border-b border-black !mb-3' : activeFilters.length > 0 }]">
                <!-- loop through active filters-->
                <li class="mb-2 px-2 py-1 inline-flex hover:cursor-pointer w-full bg-gdc-blue-800 rounded
                            justify-between items-center text-white text-sm font-bold"
                    v-for="filter in activeFilters"
                    :key="filter.id"
                    @click="toggleFilter(filter)">
                    {{filter.name}}

                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 16" style="margin: -1px 0px 0px 1px;"><path fill="#fff" d="M 15.96875 14.019531 L 9.847656 7.957031 L 15.90625 1.839844 L 14.019531 -0.03125 L 7.960938 6.089844 L 1.84375 0.03125 L -0.03125 1.902344 L 6.09375 7.972656 L 0.03125 14.097656 L 1.902344 15.96875 L 7.976562 9.839844 L 14.097656 15.90625 Z M 15.96875 14.019531"></path></svg>
                </li>
            </ul>
        </div>
    </div>
</template>

<script type="text/javascript">

export default
{
    name: "ActiveFilters",

    /**
     * Component Props
     */
    props: {

        /**
         * Current Active filters
         */
        activeFilters: {
            type: Array
        }
    },

    /**
     * Active Filters
     *
     * @return {{filters: *[]}}
     */
    data()
    {
        return {
            filters: [],
        }
    },

    computed:{

        /**
         * Clear Label Text
         * @return {*|string}
         */
        clearLabelText()
        {
            return window.translations?.slotGameFilters?.clear_label || 'CLEAR ALL';
        },

        /**
         * Filter Label Text
         * @return {*|string}
         */
        filterLabelText()
        {
            return window.translations?.slotGameFilters?.filter_label || 'Filter';
        },


    },
    methods: {

        /**
         * Clear All filters
         */
        clearFilters()
        {
            // loop through all filters and clear the is active status
            this.filters = this.filters.map((filter) =>
            {
                filter.is_active = false;
                return filter;
            });

            this.$emit('activeFiltersEvent');
        },

        /**
         * Toggle Filter that is not disabled!
         *
         * @param attribute
         */
        toggleFilter(attribute)
        {
            if (!attribute.is_disabled)
            {
                attribute.is_active = !attribute.is_active;
            }

            this.$emit('activeFiltersEvent');
        },
    },

    watch: {

        /**
         * when the prop data changed populate the two-way binding data
         * @param value
         */
        activeFilters(value)
        {
            this.filters = value;
        },
    }
}

</script>
